import { useOutletContext } from "react-router-dom";

export type WizardBasePath = "/onboarding" | "/portal/add-device";

export const useWizardBasePath = () => useOutletContext<WizardBasePath>();
